import { isPlatformBrowser } from '@angular/common';
import { Component, Inject, OnInit, PLATFORM_ID } from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';
import { ACCESS_TOKEN_KEY, ActivateEmailStates } from 'src/app/constants/app.constants';
import { User } from 'src/app/interfaces/user';
import { UserService } from 'src/app/services/user/user.service';

@Component({
  selector: 'app-activate-email',
  templateUrl: './activate-email.component.html'
})
export class ActivateEmailComponent implements OnInit {

  public activationEmailState = ActivateEmailStates.OngoingActivation;
  public ActivateEmailStates = ActivateEmailStates;
  public errorMessage: string = 'Something went wrong! Please try to reopen the link from your email ' +
  'or try to log in using your credentials and in case the issue still persist please feel free to contact us!';
  public isBrowser: boolean;

  constructor(
    private _activatedRoute: ActivatedRoute,
    private _userService: UserService,
    private _router: Router,
    @Inject(PLATFORM_ID) private platformId: Object,
  ) {
    this.isBrowser = isPlatformBrowser(this.platformId);
  }
  
  private validateAndActivateEmail(queryParams) {

    if (!queryParams || (queryParams && !queryParams.emailAddress) || (queryParams && !queryParams.evc)) {
      this.activationEmailState = ActivateEmailStates.FailedActivation;
      return;
    }
    
    this._userService.activateEmail({
      emailAddress: queryParams.emailAddress,
      emailVerificationCode: queryParams.evc
    }).subscribe({
      next: (response: User) => {
        this.activationEmailState = ActivateEmailStates.Activated;
        if (this.isBrowser) {
          localStorage.setItem(ACCESS_TOKEN_KEY, response.token);
        }
        this._router.navigate(['/account/owner-details']);
      },
      error: (err) => {
        this.activationEmailState = ActivateEmailStates.FailedActivation;
        console.error('Error activating email:', err);
      }
    });
  }

  ngOnInit() {
    if (!this.isBrowser) return; // only execute code in the browser
    const queryParams = this._activatedRoute.snapshot.queryParams;
    this.validateAndActivateEmail(queryParams);
  }
}
